import React from "react";
import ReactDOM from "react-dom";
import App from "./pages/App";
import Styles from "./globalStyles/Styles";
import reportWebVitals from "./utils/reportWebVitals";
import { RecoilRoot } from "recoil";
import { BrowserRouter as Router } from "react-router-dom";


ReactDOM.render(
  <RecoilRoot>
      <Router>
        <Styles />
        <App />
      </Router>
  </RecoilRoot>,
  document.getElementById("root")
);

reportWebVitals();
//serviceWorker.register();

